import React from "react";
import { cn } from "../../../lib/utils";
import { statusColor } from "../utils/gatewayUtils";

interface GatewayStatusBadgeProps {
  status: string;
  className?: string;
}

export default function GatewayStatusBadge({ status, className }: GatewayStatusBadgeProps) {
  return (
    <span className={cn(
      "inline-flex items-center px-1.5 py-px rounded text-[10px] font-semibold border leading-4",
      statusColor(status),
      className
    )}>
      {status}
    </span>
  );
}
